import { render, staticRenderFns } from "./TrainingPlanCard.vue?vue&type=template&id=0b36b4de&"
import script from "./TrainingPlanCard.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports